/* eslint-disable */
import { useState } from "react";
import { NavLink as NavLinkRRD, Link, useNavigate } from "react-router-dom";
import { PropTypes } from "prop-types";
import {
  Collapse,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Media,
  NavbarBrand,
  Navbar,
  NavItem,
  Nav,
  Container,
  Row,
  Col,
  Form,
  InputGroupAddon,
  InputGroupText,
  Input,
  InputGroup,
} from "reactstrap";

const Sidebar = (props) => {
  const [collapseOpen, setCollapseOpen] = useState(false);
  const [openCollapse, setOpenCollapse] = useState({});
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/auth/login");
  };

  const closeCollapse = () => setCollapseOpen(false);

  const toggleCollapse = (sectionName) => {
    setOpenCollapse((prev) => ({
      ...prev,
      [sectionName]: !prev[sectionName],
    }));
  };

  // ✅ Gera os links do menu lateral
  const createLinks = (routes) => {
    return routes.map((prop, key) => {
      // 🔹 Seção com submenus (collapse)
      if (prop.collapse && prop.views && prop.showInSidebar) {
        return (
          <NavItem key={key}>
            <NavLinkRRD
              to="#"
              onClick={(e) => {
                e.preventDefault();
                toggleCollapse(prop.name);
              }}
              className="nav-link"
            >
              <i className={prop.icon} />
              <span>{prop.name}</span>
            </NavLinkRRD>
            <Collapse isOpen={openCollapse[prop.name]}>
              <Nav className="nav-sm flex-column">
                {prop.views.map((child, childKey) => (
                  <NavItem key={`${key}-${childKey}`}>
                    <NavLinkRRD
                      to={child.layout + child.path}
                      onClick={closeCollapse}
                      className={({ isActive }) =>
                        `nav-link${isActive ? " active" : ""}`
                      }
                    >
                      <i className={child.icon || "ni ni-curved-next"} />
                      <span>{child.name}</span>
                    </NavLinkRRD>
                  </NavItem>
                ))}
              </Nav>
            </Collapse>
          </NavItem>
        );
      }

      // 🔹 Links simples
      if (prop.showInSidebar) {
        return (
          <NavItem key={key}>
            <NavLinkRRD
              to={prop.layout + prop.path}
              onClick={closeCollapse}
              className={({ isActive }) =>
                `nav-link${isActive ? " active" : ""}`
              }
            >
              <i className={prop.icon} />
              <span>{prop.name}</span>
            </NavLinkRRD>
          </NavItem>
        );
      }

      return null;
    });
  };

  const { routes, logo } = props;

  // 🔗 Configurações de logo
  let navbarBrandProps;
  if (logo && logo.innerLink) {
    navbarBrandProps = {
      to: logo.innerLink,
      tag: Link,
    };
  } else if (logo && logo.outterLink) {
    navbarBrandProps = {
      href: logo.outterLink,
      target: "_blank",
    };
  }

  return (
    <Navbar
      className="navbar-vertical fixed-left navbar-light bg-white"
      expand="md"
      id="sidenav-main"
    >
      <Container fluid>
        {/* Botão toggler mobile */}
        <button
          className="navbar-toggler"
          type="button"
          onClick={() => setCollapseOpen(!collapseOpen)}
        >
          <span className="navbar-toggler-icon" />
        </button>

        {/* Logo */}
        {logo ? (
          <NavbarBrand className="pt-0" {...navbarBrandProps}>
            <img
              alt={logo.imgAlt}
              className="navbar-brand-img"
              src={logo.imgSrc}
            />
          </NavbarBrand>
        ) : null}

        {/* Menu de usuário (modo mobile) */}
        <Nav className="align-items-center d-md-none">
          <UncontrolledDropdown nav>
            <DropdownToggle className="nav-link pr-0" color="" tag="a">
              <Media className="align-items-center">
                <span className="avatar avatar-sm rounded-circle">
                  <i className="ni ni-single-02" />
                </span>
              </Media>
            </DropdownToggle>
            <DropdownMenu
              container="body"
              className="dropdown-menu-arrow"
              right
            >
              <DropdownItem className="noti-title" header tag="div">
                <h6 className="text-overflow m-0">Bem-vindo!</h6>
              </DropdownItem>
              <DropdownItem to="/admin/user-profile" tag={Link}>
                <i className="ni ni-single-02" />
                <span>Meu perfil</span>
              </DropdownItem>
              <DropdownItem divider />
              <DropdownItem href="#logout" onClick={handleLogout}>
                <i className="ni ni-user-run" />
                <span>Sair</span>
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        </Nav>

        {/* Menu lateral */}
        <Collapse navbar isOpen={collapseOpen}>
          {/* Header mobile */}
          <div className="navbar-collapse-header d-md-none">
            <Row>
              {logo ? (
                <Col className="collapse-brand" xs="6">
                  {logo.innerLink ? (
                    <Link to={logo.innerLink}>
                      <img alt={logo.imgAlt} src={logo.imgSrc} />
                    </Link>
                  ) : (
                    <a href={logo.outterLink}>
                      <img alt={logo.imgAlt} src={logo.imgSrc} />
                    </a>
                  )}
                </Col>
              ) : null}
              <Col className="collapse-close" xs="6">
                <button
                  className="navbar-toggler"
                  type="button"
                  onClick={() => setCollapseOpen(!collapseOpen)}
                >
                  <span />
                  <span />
                </button>
              </Col>
            </Row>
          </div>

          {/* 🔎 Campo de pesquisa (mobile) */}
          <Form className="mt-4 mb-3 d-md-none">
            <InputGroup className="input-group-rounded input-group-merge">
              <Input
                aria-label="Pesquisar"
                className="form-control-rounded form-control-prepended"
                placeholder="Pesquisar"
                type="search"
              />
              <InputGroupAddon addonType="prepend">
                <InputGroupText>
                  <span className="fa fa-search" />
                </InputGroupText>
              </InputGroupAddon>
            </InputGroup>
          </Form>

          {/* 🔗 Links do menu lateral */}
          <Nav navbar>{createLinks(routes)}</Nav>
        </Collapse>
      </Container>
    </Navbar>
  );
};

Sidebar.defaultProps = {
  routes: [],
};

Sidebar.propTypes = {
  routes: PropTypes.arrayOf(PropTypes.object),
  logo: PropTypes.shape({
    innerLink: PropTypes.string,
    outterLink: PropTypes.string,
    imgSrc: PropTypes.string.isRequired,
    imgAlt: PropTypes.string.isRequired,
  }),
};

export default Sidebar;